module.exports = __webpack_public_path__ + "static/pyramids_star_shaft-ac7e431512abdc5af4264fb66152154b.png";